import axios from "axios";

export default axios.create({
  baseURL: "https://m2aconsultoria.pythonanywhere.com",
});
